import {grey} from "@mercedes-benz/mbui-theme";

const styles = ({ theme }) => ({
    '&': {
        minHeight: '200px',
        padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
        backgroundColor: grey[90],

        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            width: '100%',
            left: '0',
            right: '0',
            bottom: '72px',
            height: '240px',
            paddingLeft: `calc(33vw + ${theme.spacing(2)} + ${theme.spacing(3)})`,
            paddingRight: `${theme.spacing(6)}`,
        },

        [theme.breakpoints.up('lg')]: {
            paddingLeft: `calc(((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.33) + ${theme.spacing(3)})`,
        },

        '.ResultArea-stack': {
            flexDirection: 'column',
            '.MuiTypography-h4': {
                marginBottom: theme.spacing(1),
            },

            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',

                '.MuiBox-root': {
                    flex: '1 1 50%',
                },
            },
        },
        '.Footprint-table': {
            borderSpacing: '0',
            '& td': {
                border: 0,
                padding: '0',
                
                '&:first-child': {
                    paddingRight: theme.spacing(2),
                }
            }
        },
    },
    '&.MuiPaper-elevation1': {
        zIndex: '100'
    },
    '&.MuiPaper-elevation2': {
        zIndex: '200'
    },
    '&.MuiPaper-elevation3': {
        zIndex: '300'
    }
});

export default styles